import PropTypes from 'prop-types';
import {intlShape, injectIntl} from 'react-intl';

import React from 'react';

class FooterDeleteButton extends React.Component {
  static defaultProps = {
    confirmText: 'Confirm',
    cancelText: 'Cancel',
  };

  static propTypes = {
    cancelText: PropTypes.string,
    children: PropTypes.any.isRequired,
    confirmText: PropTypes.string,
    intl: intlShape.isRequired,
    onDelete: PropTypes.func.isRequired,
  };

  state = {confirming: false};

  onCancel = () => {
    this.setState({confirming: false});
  };

  delete = () => {
    this.setState({confirming: true});
  };

  deleteConfirm = (e) => {
    this.setState({confirming: false});
    this.props.onDelete(e);
  };

  render() {
    if (this.state.confirming) {
      return (
        <span className='pull-right'>
          <i className='bl bl-trash blue' style={{fontSize: '24px'}}/>
          &nbsp;
          <a className='pointer b underline' onClick={this.deleteConfirm}>
            {this.props.intl.formatMessage({id: 'general.confirm'})}
          </a> | <a className='pointer dim underline' onClick={this.onCancel}>
            {this.props.intl.formatMessage({id: 'general.cancel'})}
          </a>
        </span>
      );
    }

    return (
      <span className='pull-right pointer' onClick={this.delete}>
        <i className='bl bl-trash blue' style={{fontSize: '24px'}}/>
      </span>
    );
  }
}

export default injectIntl(FooterDeleteButton);
